import React from 'react';
import { ReCommerceLayout } from './components/ReCommerceLayout';
import { RepairProgramPage } from './repairs/repair-program-page';
import { RepairAnalyticsPage } from './repairs/repair-analytics-page';
import { RepairOverviewPage } from './repairs/repair-overview-page';
import { RepairListPage } from './repairs/repair-list-page';
import { RepairDetailPage } from './repairs/repair-detail-page';
import { RepairTechniciansPage } from './repairs/repair-technicians-page';
import { RepairSettingsPage } from './repairs/repair-settings-page';
import { RepairLayout } from './repairs/repair-layout';
import { ResaleOverviewPage } from './resale/resale-overview-page';
import { ResaleItemsPage } from './resale/resale-items-page';
import { ResaleDetailPage } from './resale/resale-detail-page';
import { ResaleAnalyticsPage } from './resale/resale-analytics-page';
import { ResaleEnvironmentPage } from './resale/resale-environment-page';
import { ResaleFinancialsPage } from './resale/resale-financials-page';
import { ResaleInformationPage } from './resale/resale-information-page';
import { ResaleSettingsPage } from './resale/resale-settings-page';
import { ResaleLayout } from './resale/resale-layout';
import { ResaleOrdersPage } from './resale/resale-orders-page';
import { RefillLayout } from './refill/refill-layout';
import { RefillDashboardPage } from './refill/refill-dashboard';
import { RefillContainersPage } from './refill/refill-containers-page';
import { RefillStationsPage } from './refill/refill-stations-page';
import { RefillSubscriptionsPage } from './refill/refill-subscriptions-page';
import { RefillAnalyticsPage } from './refill/refill-analytics-page';
import { RefillReturnsPage } from './refill/refill-returns-page';
import { RefillSettingsPage } from './refill/refill-settings-page';
import { RefillDetailPage } from './refill/refill-detail-page';
import { InboundLayout } from './inbound/inbound-layout';
import { InboundOverviewPage } from './inbound/inbound-overview-page';
import { InboundListPage } from './inbound/inbound-list-page';
import { InboundDetailPage } from './inbound/inbound-detail-page';
import { RentalLayout } from './rental/rental-layout';
import { RentalOverviewPage } from './rental/rental-overview-page';
import { RentalItemsPage } from './rental/rental-items-page';
import { RentalOrdersPage } from './rental/rental-orders-page';
import { RentalAnalyticsPage } from './rental/rental-analytics-page';
import { RentalSettingsPage } from './rental/rental-settings-page';
import { RecycleLayout } from './recycle/recycle-layout';
import { RecyclePage } from './recycle/recycle-page';
import { RecycleDetailPage } from './recycle/recycle-detail-page';
import { RecycleAnalyticsPage } from './recycle/recycle-analytics-page';
import { RecycleEnvironmentPage } from './recycle/recycle-environment-page';
import { RecycleFinancialsPage } from './recycle/recycle-financials-page';
import { RecycleInformationPage } from './recycle/recycle-information-page';
import { RecycleProgramPage } from './recycle/recycle-program-page';
import { RecycleItemsPage } from './recycle/recycle-items-page';
import { RentalItemDetailPage } from './rental/rental-item-detail-page';
import { RentalOrderDetailPage } from './rental/rental-order-detail-page';
import { RentalProgramPage } from './rental/rental-program-page';
import { RentalMaintenancePage } from './rental/rental-maintenance-page';

export const reCommerceRoutes = {
  path: '/admin/re-commerce',
  element: <ReCommerceLayout />,
  children: [
    {
      path: 'inbound',
      element: <InboundLayout />,
      children: [
        {
          index: true,
          element: <InboundOverviewPage />,
        },
        {
          path: 'list',
          element: <InboundListPage />,
        },
        {
          path: ':id',
          element: <InboundDetailPage />,
        },
      ],
    },
    {
      path: 'repairs',
      element: <RepairLayout />,
      children: [
        {
          index: true,
          element: <RepairOverviewPage />,
        },
        {
          path: 'list',
          element: <RepairListPage />,
        },
        {
          path: ':id',
          element: <RepairDetailPage />,
        },
        {
          path: 'technicians',
          element: <RepairTechniciansPage />,
        },
        {
          path: 'program',
          element: <RepairProgramPage />,
        },
        {
          path: 'analytics',
          element: <RepairAnalyticsPage />,
        },
        {
          path: 'settings',
          element: <RepairSettingsPage />,
        },
      ],
    },
    {
      path: 'resale',
      element: <ResaleLayout />,
      children: [
        {
          index: true,
          element: <ResaleOverviewPage />,
        },
        {
          path: 'items',
          element: <ResaleItemsPage />,
        },
        {
          path: 'items/:id',
          element: <ResaleDetailPage />,
        },
        {
          path: 'orders',
          element: <ResaleOrdersPage />,
        },
        {
          path: 'analytics',
          element: <ResaleAnalyticsPage />,
        },
        {
          path: 'environment',
          element: <ResaleEnvironmentPage />,
        },
        {
          path: 'financials',
          element: <ResaleFinancialsPage />,
        },
        {
          path: 'information',
          element: <ResaleInformationPage />,
        },
        {
          path: 'settings',
          element: <ResaleSettingsPage />,
        },
      ],
    },
    {
      path: 'rental',
      element: <RentalLayout />,
      children: [
        {
          index: true,
          element: <RentalOverviewPage />,
        },
        {
          path: 'items',
          element: <RentalItemsPage />,
        },
        {
          path: 'items/:id',
          element: <RentalItemDetailPage />,
        },
        {
          path: 'orders',
          element: <RentalOrdersPage />,
        },
        {
          path: 'orders/:id',
          element: <RentalOrderDetailPage />,
        },
        {
          path: 'program',
          element: <RentalProgramPage />,
        },
        {
          path: 'maintenance',
          element: <RentalMaintenancePage />,
        },
        {
          path: 'analytics',
          element: <RentalAnalyticsPage />,
        },
        {
          path: 'settings',
          element: <RentalSettingsPage />,
        },
      ],
    },
    {
      path: 'refill',
      element: <RefillLayout />,
      children: [
        {
          index: true,
          element: <RefillDashboardPage />,
        },
        {
          path: 'containers',
          element: <RefillContainersPage />,
        },
        {
          path: 'containers/:id',
          element: <RefillDetailPage />,
        },
        {
          path: 'stations',
          element: <RefillStationsPage />,
        },
        {
          path: 'subscriptions',
          element: <RefillSubscriptionsPage />,
        },
        {
          path: 'returns',
          element: <RefillReturnsPage />,
        },
        {
          path: 'analytics',
          element: <RefillAnalyticsPage />,
        },
        {
          path: 'settings',
          element: <RefillSettingsPage />,
        },
      ],
    },
    {
      path: 'recycle',
      element: <RecycleLayout />,
      children: [
        {
          index: true,
          element: <RecyclePage />,
        },
        {
          path: 'items',
          element: <RecycleItemsPage />,
        },
        {
          path: 'program',
          element: <RecycleProgramPage />,
        },
        {
          path: 'analytics',
          element: <RecycleAnalyticsPage />,
        },
        {
          path: 'environment',
          element: <RecycleEnvironmentPage />,
        },
        {
          path: 'financials',
          element: <RecycleFinancialsPage />,
        },
        {
          path: 'information',
          element: <RecycleInformationPage />,
        },
        {
          path: ':id',
          element: <RecycleDetailPage />,
        },
      ],
    },
    // Additional routes for other re-commerce features will be added here
    // as they are implemented (rental, refill, recycle, etc.)
  ],
};
